export const VISIBLE_CLASS_NAME = 'visible';

const SELECTORS = {
  ITEM: '.js-accordion-item',
  BTN: '.js-accordion-btn',
  CONTENT: '.js-accordion-content',
};

export default () => {
  const changeContentMaxHeight = (btn) => {
    const item = btn.closest(SELECTORS.ITEM);
    const content = item.querySelector(SELECTORS.CONTENT);
    const isActiveItem = item.classList.contains(VISIBLE_CLASS_NAME);

    if (isActiveItem) {
      content.style.maxHeight = `${content.scrollHeight}px`;
    } else {
      content.style.maxHeight = '0px';
    }
  };

  const updateAllContents = () => {
    Array.from(document.querySelectorAll(SELECTORS.BTN)).forEach(changeContentMaxHeight);
  };

  let lastWindowWidth;
  let resizeTimeout;

  document.addEventListener('click', (event) => {
    const btn = event.target.closest(SELECTORS.BTN);

    if (!btn) {
      return;
    }

    event.preventDefault();
    btn.closest(SELECTORS.ITEM).classList.toggle(VISIBLE_CLASS_NAME);
    changeContentMaxHeight(btn);
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth === lastWindowWidth) {
      return;
    }

    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateAllContents);
    lastWindowWidth = window.innerWidth;
  });

  if (document.readyState !== 'complete') {
    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        updateAllContents();
      }
    };
  } else {
    updateAllContents();
  }
};
